var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"travels-view"},[(_vm.loaded)?_c('HubTravels',{attrs:{"name":"travels","overview":_vm.overview,"users":_vm.users,"user":_vm.user}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }